import { hasCapability } from "@vninvestcharts/engine-core";
import { defaultAdapters } from "@vninvestcharts/engine-react";
import { WorkspaceManager } from "./WorkspaceManager";
/** Lỗi có mã để UI hiển thị đúng thay vì nuốt im lặng. */
export class WorkspaceStoreError extends Error {
    code;
    constructor(message, code) {
        super(message);
        this.code = code;
        this.name = "WorkspaceStoreError";
    }
}
// ---------------------------------------------------------------------------
// Local — bọc WorkspaceManager + StorageAdapter (localStorage mặc định)
// ---------------------------------------------------------------------------
export class LocalWorkspaceStore {
    storage;
    scope = "local";
    supportsMultiDevice = false;
    constructor(storage = defaultAdapters.storageAdapter) {
        this.storage = storage;
    }
    list() {
        return WorkspaceManager.list(this.storage);
    }
    load(id) {
        return WorkspaceManager.load(id, this.storage);
    }
    async save(data) {
        try {
            await WorkspaceManager.save(data, this.storage);
            await WorkspaceManager.addToIndex({ id: data.id, name: data.name, updatedAt: data.updatedAt }, this.storage);
        }
        catch (err) {
            // localStorage đầy (quota) là lỗi thật, không phải "không lưu được im lặng".
            throw new WorkspaceStoreError(err instanceof Error ? err.message : "local save failed", "quota_exceeded");
        }
    }
    remove(id) {
        return WorkspaceManager.delete(id, this.storage);
    }
}
// ---------------------------------------------------------------------------
// Remote — STUB. Chỉ dùng được sau EP-8 (`/core/v1/workspace/v1/*`).
// ---------------------------------------------------------------------------
export class RemoteWorkspaceStore {
    scope = "cloud";
    supportsMultiDevice = true;
    /**
     * Ném **promise bị từ chối**, không throw đồng bộ.
     *
     * Lý do: interface khai `Promise<T>`, nên caller viết `store.list().catch(...)`
     * phải bắt được. `throw` đồng bộ sẽ vượt qua `.catch` và làm hỏng luồng
     * async của người gọi.
     */
    unavailable() {
        return Promise.reject(new WorkspaceStoreError("Cloud workspace needs the backend workspace API (EP-8), which is not deployed yet.", "not_implemented"));
    }
    list() {
        return this.unavailable();
    }
    load(_id) {
        return this.unavailable();
    }
    save(_data) {
        return this.unavailable();
    }
    remove(_id) {
        return this.unavailable();
    }
}
export function resolveWorkspaceStore(input) {
    const local = () => new LocalWorkspaceStore(input.storageAdapter ?? defaultAdapters.storageAdapter);
    if (input.forceRemote === true)
        return new RemoteWorkspaceStore();
    if (input.forceRemote === false)
        return local();
    // Cần CẢ HAI: đủ quyền (enterprise) + backend thật (EP-8 đã deploy).
    if (input.allowsCloud && input.backendReady === true)
        return new RemoteWorkspaceStore();
    return local();
}
/** Rút gọn: suy ra `allowsCloud` từ tier + narrowing license. */
export function allowsCloudWorkspace(tier, narrowing) {
    if (!hasCapability(tier, "server_workspace"))
        return false;
    return !narrowing || narrowing.length === 0 || narrowing.includes("server_workspace");
}
